import React, { useState, useEffect } from "react";
import { Card, Modal, Form, Button } from '@themesberg/react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { editarRolAction, cerrarModalEditarAction } from '../../actions/rolesActions';

export default (props) => {
    const dispatch = useDispatch();

    const { rol, showModalEditar } = useSelector(state => state.roles);

    const [ rolEdicion, guardarRol] = useState({
        'nombre': '',
        'descripcion': ''
    })

    useEffect(() => {
        guardarRol(rol);
    }, [rol])

    const submitEditarRol = e => {
        e.preventDefault();
        dispatch( editarRolAction(rolEdicion) );
    }

    const handleClose = () => {
        dispatch( cerrarModalEditarAction() );
    }

    const onChangeForm = (e) => {
        guardarRol({
            ...rolEdicion,
            [e.target.name] : e.target.value
        })
    }

    return (
        <Modal as={Modal.Dialog} centered show={showModalEditar} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title className="h6">Editar rol</Modal.Title>
                <Button variant="close" aria-label="Close" onClick={handleClose} />
            </Modal.Header>
            <Form onSubmit={submitEditarRol}>
            <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control type="text" name="nombre" placeholder="Nombre del rol" 
                            value={rolEdicion.nombre} onChange={onChangeForm} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Descripción del rol</Form.Label>
                        <Form.Control type="text" name="descripcion" placeholder="Descripción del rol" 
                            value={rolEdicion.descripcion} onChange={onChangeForm} />
                    </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="link" className="text-gray ms-auto" onClick={handleClose}>
                    Cerrar
                </Button>
                <Button type="submit" variant="secondary">
                    Guardar
                </Button>
            </Modal.Footer>
            </Form>
        </Modal>
    );
}